/**
 * Profile API endpoints by role.
 * Use these when calling profile GET/PUT so manager and staff use their own APIs.
 */
export const getProfileEndpoint = (role: string): string => {
  switch (role) {
    case 'merchant':
      return 'merchant/profile';
    case 'merchant_manager':
      return 'manager/profile';
    case 'merchant_staff':
      return 'staff/profile';
    case 'admin':
    default:
      return 'admin/profile';
  }
};

export const getProfileUpdatePath = (role: string, userId: number | string): string => {
  switch (role) {
    case 'merchant':
      return `/merchant/${userId}`;
    case 'merchant_manager':
      return `/manager/${userId}`;
    case 'merchant_staff':
      return `/staff/${userId}`;
    case 'admin':
    default:
      return `/admin/${userId}`;
  }
};
